const FFA = {
  capability: 'Capability',
  product: 'Product',
  productProperty: 'funds_now_instant',
  capabilityProperty: 'instant_funds',
  FFAOptIn: 'FFA_Opt_In',
  productAttr: 'funds_now_instant',
  enrollAttr: 'instant_funds_enrollment',
  capabilityAttr: 'instant_funds_enabled_y_n',
  fundsMap: [
    'SUBSCRIPTION',
    'SUBSCRIPTION:ACTION-REQUIRED',
    'SUBSCRIPTION:REVIEW',
    'INELIGIBLE',
    'APPLICATION:ACTION-REQUIRED',
    'INACTIVE:PP-CANCELLED',
    'INACTIVE:USER-CANCELLED',
    'ELIGIBLE:OFFERED:CANCELLED'
  ],
  pricingCall: [
    'INELIGIBLE',
    'INACTIVE:PP-CANCELLED',
    'INACTIVE:USER-CANCELLED',
    'ELIGIBLE:OFFERED:CANCELLED',
    'APPLICATION:ACTION-REQUIRED',
    'SUBSCRIPTION'
  ]
};

const ACCOUNT_TYPE = 'BUSINESS';

const PAYPAL_HOME_PAGE = 'https://www.paypal.com';
const COUNTRY_CODE = 'US';

const KEYMAKER = {
  CRYPT_KEY_ID: 'encrypted_crypt_key',
  MAC_KEY_ID: 'encrypted_mac_key'
};

const PARTNER = {
  WALMART: {
    LINK: 'https://www.paypal-business.com/walmart',
    NAME: 'walmart'
  }
};

const TOOLS = {
  FUNDSNOW: {
    ELIGIBLE_LINK: 'https://www.paypal.com/businessprovision/benefits',
    SUBSCRIPTION_NAME: 'subscription',
    ELIGIBILITY_NAME: 'eligible',
    SUBSCRIPTION_LINK: 'https://www.paypal.com/businessprovision/funds'
  },
  SENDMONEY: { NAME: 'pp_send_money' },
  REQUESTMONEY: { NAME: 'pp_request_money' },
  BUTTONFACTORY: { NAME: 'pp_buttons' },
  SHIPPING: { NAME: 'pp_multi_order_shipping' },
  RESCENTER: { NAME: 'pp_resolution_center' }
};

const LOGGER_CONSTANTS = {
  GET_CONSENTS: 'getConsents',
  VERIFY_CONSENT: 'verifyConsent',
  CHECK_ELIGIBILITY: 'checkEligibility',
  GET_EXPERIMENT: 'getExperiment',
  GET_CONTACTS: 'getContacts',
  GET_SEGMENTS: 'getSegments',
  UPDATE_CUSTOMER_LIST: 'updateCustomerList',
  UPDATE_USER: 'updateUser',
  GET_MESSAGES: 'getMessages'
};

const CONFIRM_EMAIL_STATUS = 'CONFIRM';

const DEV_HOST = 'msmaster.qa.paypal.com';

const TOUCHPOINTS = {
  MAIN: 'Merchhub_AppCenterMain_Page',
  CATEGORY: 'Merchhub_Category_Page',
  DETAILS: 'Merchhub_Details_Page',
  HEADER: 'Merchhub_Header',
  FEATURES: 'Merchhub_Features',
  PICTURE_ROW: 'Merchhub_Picture_Row',
  FEES: 'Merchhub_Fees',
  FOOTER: 'Merchhub_Footer',
  TERMS_AND_CONDITIONS: 'Merchhub_terms_and_Condition',
  SECTION_HEADER: 'Merchhub_Section_Header',
  SETUP: 'Merchhub_setup',
  CTA_SECTION: 'Merchhub_CTA_Section',
  SEO: 'PPCP_App_Center_SEO',
  TOOLS: 'PPCP_App_Center_Tool',
  LAYOUTS: 'PPCP_App_Center_Tools_Layout_LoggedIn',
  LAYOUTS_LOGGED_OUT: 'PPCP_App_Center_Tools_Layout_LoggedOut',
  MAIN_PAGE: 'PPCP_App_Center_Main_Page',
  CATEGORIES: 'PPCP_App_Center_Category',
  SECTIONS: 'PPCP_App_Center_Section',
  RECOMMENDED: 'PPCP_AppCenter_Recommended_Row'
};

const DETAILS_HEADER = 'DetailsHeader';
const DETAILS_FEATURES = 'DetailsFeatures';
const DETAILS_PHOTO_ROW = 'DetailsPhotoRow';
const DETAILS_FEES = 'DetailsFees';
const DETAILS_FOOTER = 'DetailsFooter';
const DETAILS_TERMS_AND_CONDITIONS = 'DetailsTermsAndConditions';
const DETAILS_SECTION_HEADER = 'DetailsSectionHeader';
const DETAILS_SETUP = 'DetailsSetup';
const DETAILS_CTA_SECTION = 'DetailsCTASection';

const TOUCHPOINT_TO_COMPONENT_MAP = {
  [TOUCHPOINTS.HEADER]: DETAILS_HEADER,
  [TOUCHPOINTS.FEATURES]: DETAILS_FEATURES,
  [TOUCHPOINTS.PICTURE_ROW]: DETAILS_PHOTO_ROW,
  [TOUCHPOINTS.FEES]: DETAILS_FEES,
  [TOUCHPOINTS.FOOTER]: DETAILS_FOOTER,
  [TOUCHPOINTS.TERMS_AND_CONDITIONS]: DETAILS_TERMS_AND_CONDITIONS,
  [TOUCHPOINTS.SECTION_HEADER]: DETAILS_SECTION_HEADER,
  [TOUCHPOINTS.SETUP]: DETAILS_SETUP,
  [TOUCHPOINTS.CTA_SECTION]: DETAILS_CTA_SECTION
};

const TOUCHPOINT_CODE_TO_NAME = {
  [TOUCHPOINTS.TOOLS]: 'tools',
  [TOUCHPOINTS.LAYOUTS]: 'layouts',
  [TOUCHPOINTS.LAYOUTS_LOGGED_OUT]: 'layouts',
  [TOUCHPOINTS.MAIN_PAGE]: 'main',
  [TOUCHPOINTS.CATEGORIES]: 'categories',
  [TOUCHPOINTS.SECTIONS]: 'sections',
  [TOUCHPOINTS.SEO]: 'seo',
  [TOUCHPOINTS.RECOMMENDED]: 'recommended'
};

const RPS_FAVORITE_ATTRIBUTE = 'ppcp_merch_app_store_favs';

const SET_INTENT_AND_REDIRECT_CONFIG = {
  woo_connect: {
    redirectUrl: '/mep/dashboard/#ppcp_woocommerce_connect-expanded',
    rpsSetupIntent: 'wooSpbConnect'
  },
  woo_manual: {
    redirectUrl: '/commerce-apps/woocommerce/instructions',
    rpsSetupIntent: 'wooSpbManual'
  }
};

const INTENT_ERRORS = {
  INVALID_INTENT: 'invalid_intent',
  MISSING_PARAMETER: 'missing_parameter'
};

export default {
  FFA,
  ACCOUNT_TYPE,
  PAYPAL_HOME_PAGE,
  COUNTRY_CODE,
  KEYMAKER,
  PARTNER,
  TOOLS,
  LOGGER_CONSTANTS,
  CONFIRM_EMAIL_STATUS,
  DEV_HOST,
  TOUCHPOINTS,
  TOUCHPOINT_TO_COMPONENT_MAP,
  DETAILS_HEADER,
  DETAILS_FEATURES,
  DETAILS_PHOTO_ROW,
  DETAILS_FEES,
  DETAILS_FOOTER,
  DETAILS_TERMS_AND_CONDITIONS,
  DETAILS_SECTION_HEADER,
  DETAILS_SETUP,
  DETAILS_CTA_SECTION,
  RPS_FAVORITE_ATTRIBUTE,
  TOUCHPOINT_CODE_TO_NAME,
  SET_INTENT_AND_REDIRECT_CONFIG,
  INTENT_ERRORS
};

export {
  FFA,
  ACCOUNT_TYPE,
  PAYPAL_HOME_PAGE,
  COUNTRY_CODE,
  KEYMAKER,
  PARTNER,
  TOOLS,
  LOGGER_CONSTANTS,
  CONFIRM_EMAIL_STATUS,
  DEV_HOST,
  TOUCHPOINTS,
  TOUCHPOINT_TO_COMPONENT_MAP,
  DETAILS_HEADER,
  DETAILS_FEATURES,
  DETAILS_PHOTO_ROW,
  DETAILS_FEES,
  DETAILS_FOOTER,
  DETAILS_TERMS_AND_CONDITIONS,
  DETAILS_SECTION_HEADER,
  DETAILS_SETUP,
  DETAILS_CTA_SECTION,
  RPS_FAVORITE_ATTRIBUTE,
  TOUCHPOINT_CODE_TO_NAME,
  SET_INTENT_AND_REDIRECT_CONFIG,
  INTENT_ERRORS
};
